import React from 'react';
import { styled } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Colors } from 'library';

interface RChipProps {
    children: React.ReactNode;
    variant?: 'outlined' | 'filled';
    bgColor?: string;
    borderColor?: string;
    textColor?: string;
    size?: 'small' | 'medium';
    removable?: boolean;
    onRemove?: (e: React.MouseEvent) => void;
}

export function RChip({
    children,
    variant = 'outlined',
    bgColor,
    borderColor,
    textColor,
    size = 'medium',
    removable,
    onRemove,
}: RChipProps) {
    return (
        <Chip variant={variant} bgColor={bgColor} borderColor={borderColor} textColor={textColor} size={size}>
            {children}
            {removable && (
                <RemoveButton onClick={onRemove} type="button">
                    <Close sx={{ fontSize: size === 'small' ? 12 : 14 }} />
                </RemoveButton>
            )}
        </Chip>
    );
}

const Chip = styled('span')<{
    variant: 'outlined' | 'filled';
    bgColor?: string;
    borderColor?: string;
    textColor?: string;
    size?: 'small' | 'medium';
}>(({ variant, bgColor, borderColor, textColor, size }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: size === 'small' ? '1px 6px' : '3px 7px',
    borderRadius: 16,
    fontSize: size === 'small' ? 11 : 13,
    fontWeight: 500,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    ...(variant === 'outlined' && {
        color: textColor ?? Colors.mediumGrey,
        backgroundColor: bgColor ?? Colors.white,
        border: `1px solid ${borderColor ?? Colors.lightGrey}`,
    }),
    ...(variant === 'filled' && {
        color: textColor ?? Colors.white,
        backgroundColor: bgColor ?? Colors.darkNavy,
        border: borderColor ? `1px solid ${borderColor}` : 'none',
    }),
}));

const RemoveButton = styled('button')({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 16,
    height: 16,
    marginLeft: 2,
    padding: 0,
    border: 'none',
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: 'inherit',
    cursor: 'pointer',
    opacity: 0.7,
    '&:hover': {
        opacity: 1,
        backgroundColor: 'rgba(0,0,0,0.08)',
    },
});
